// https://vuex.vuejs.org/en/state.html
/* eslint no-param-reassign:0 */
export default {
  collections: state => state.collections,
  collection: state => state.collection,
  products: state => state.products,
  status: state => state.status,
};
